import { render } from "./QBETemporalFilterDialog.vue?vue&type=template&id=22a5fd8a&ts=true"
import script from "./QBETemporalFilterDialog.vue?vue&type=script&lang=ts"
export * from "./QBETemporalFilterDialog.vue?vue&type=script&lang=ts"

import "./QBETemporalFilterDialog.vue?vue&type=style&index=0&id=22a5fd8a&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__